module.exports = __webpack_public_path__ + "static/media/login.2f2eb5db.svg";